import { util } from 'pevueglobal'

// state
const state = {
  membershipdata: [],
  activitydata: []
}
// getters
const getters = {
  membershipdata: state => state.membershipdata,
  activitydata: state => state.activitydata
}
// actions
const actions = {
  getmembercarddetails: async ({ commit }) => {
    const data = await util.getDataApi('prof/PEapi_PR_MyMemberCard')
    if (data.ds.data0.length === 1) {
      commit('setmembercarddetails', data)
    }
  }
}

// mutations
const mutations = {
  setmembercarddetails(state, data) {
    state.membershipdata = data.ds.data0[0]
    state.activitydata = data.ds.data1
  }
}
export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
